import { createSelector } from "reselect"
import { getFilter, getClassifications, getClassificationsValues, getSecuritiesDescriptors, getPortfolioFilters } from "./filters"
import { getTagCategories, getAttributeCategories } from "modules/portfolio-root/selectors"
import { getCurrency } from "modules/portfolio-root/selectors/portfolios"
import { computeFilterChips } from "helpers/filters/chips"

export const getChips = createSelector(
  [getFilter, getTagCategories, getClassifications, getSecuritiesDescriptors, getPortfolioFilters, getAttributeCategories, getClassificationsValues, getCurrency],
  computeFilterChips,
)
